import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IDealerInformationVDF } from '../models/model'

export class UpdateDealerInformationApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/vodafoneDealer/updateDealerInformationVDF',
      requesterInfo,
    })
  }

  public async updateDealerInformationList(dealerInfo: IDealerInformationVDF[]): Promise<any> {
    return await this.postAsync<any>(dealerInfo)
  }
}
